module.exports = __webpack_public_path__ + "img/h5_P8.1ce022d1.png";